export default "__VITE_ASSET__123f7c9f__"